import { useTranslation } from 'react-i18next'
import MainLogo from 'components/assets/icons/MainLogo'
import LanguageSelector from 'components/LanguageSelector/LanguageSelector'
import Lock from 'components/assets/icons/Lock'
import { getLoginBrand } from 'config/loginDesign'
import style from './LoginLayout.module.scss'

const BrandLogo = ({ brand }) => {
  if (brand.logoUrl) return <img className={style['logo-img']} src={brand.logoUrl} alt={brand.name} />
  return <MainLogo styles={{ fill: brand.dark }} />
}

// Élément du pied de page : lien (nouvel onglet) si la marque en définit un, simple texte sinon
const FooterItem = ({ href, className, children }) => href
  ? <a className={`${style['footer-link']} ${className || ''}`} href={href} target="_blank" rel="noopener noreferrer">{children}</a>
  : <span className={className}>{children}</span>

// Mise en page du nouveau design de connexion : formulaire à gauche, panneau visuel à droite.
const LoginLayout = ({ title, subtitle, children }) => {
  const { t } = useTranslation()
  const brand = getLoginBrand()
  const cssVars = {
    '--lg-primary': brand.primary,
    '--lg-title': brand.title,
    '--lg-dark': brand.dark,
    '--lg-mid': brand.mid,
    '--lg-soft': brand.soft,
  }
  const chips = ['contracts', 'certificates', 'claims']

  return (
    <div className={style.page} style={cssVars}>
      <section className={style.left}>
        <header className={style.header}>
          <BrandLogo brand={brand} />
          <LanguageSelector />
        </header>

        <div className={style.main}>
          <div className={style.card}>
            <h1 className={style.title}>{title}</h1>
            {subtitle && <p className={style.subtitle}>{subtitle}</p>}
            {children}
          </div>
        </div>

        <footer className={style.footer}>
          <FooterItem href={brand.links?.secure} className={style.secure}><Lock />{t('common:loginNew.secure', 'Connexion sécurisée')}</FooterItem>
          <FooterItem href={brand.links?.help}>{t('common:loginNew.help', 'Aide')}</FooterItem>
          <FooterItem href={brand.links?.privacy}>{t('common:loginNew.privacy', 'Confidentialité')}</FooterItem>
        </footer>
      </section>

      <aside
        className={style.visual}
        style={brand.imageUrl ? { backgroundImage: `url(${brand.imageUrl})` } : undefined}
      >
        <div className={style.glass}>
          <p>{t('common:loginNew.tagline', 'Vos contrats, attestations et déclarations de sinistre, réunis au même endroit.')}</p>
          <ul>
            {chips.map(chip => (
              <li key={chip}>{t(`common:loginNew.chips.${chip}`, { defaultValue: { contracts: 'Contrats', certificates: 'Attestations', claims: 'Sinistres' }[chip] })}</li>
            ))}
          </ul>
        </div>
      </aside>
    </div>
  )
}

export default LoginLayout
